import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { HeartIcon } from 'lucide-react';
interface LikeAnimationProps {
  isVisible: boolean;
}
const LikeAnimation: React.FC<LikeAnimationProps> = ({
  isVisible
}) => {
  return <AnimatePresence data-id="element-120">
      {isVisible && <motion.div className="absolute inset-0 flex items-center justify-center z-50 pointer-events-none" initial={{
      opacity: 0,
      scale: 0.5
    }} animate={{
      opacity: [0, 1, 1, 0],
      scale: [0.5, 1.2, 1, 0.8]
    }} transition={{
      duration: 0.8,
      times: [0, 0.2, 0.6, 1],
      ease: 'easeOut'
    }} data-id="element-121">
          <HeartIcon className="w-24 h-24 text-white fill-white" data-id="element-122" />
        </motion.div>}
    </AnimatePresence>;
};
export default LikeAnimation;